<template>
  <svg
    id="b" class="mr-1" xmlns="http://www.w3.org/2000/svg" width="19" height="13"
    viewBox="0 0 34.27 21.18"
  >
    <g>
      <g>
        <rect y="6.52" width="34.27" height="1.63" fill="#db312d" />
        <rect y="3.26" width="34.27" height="1.63" fill="#db312d" />
        <rect width="34.27" height="1.63" fill="#db312d" />
        <rect y="9.78" width="34.27" height="1.63" fill="#db312d" />
        <rect y="13.04" width="34.27" height="1.63" fill="#db312d" />
        <rect y="16.3" width="34.27" height="1.63" fill="#db312d" />
        <rect y="19.55" width="34.27" height="1.63" fill="#db312d" />
      </g>
      <rect y="4.89" width="34.27" height="1.63" fill="#fff" />
      <rect y="1.63" width="34.27" height="1.63" fill="#fff" />
      <rect y="8.15" width="34.27" height="1.63" fill="#fff" />
      <rect y="11.4" width="34.27" height="1.63" fill="#fff" />
      <rect y="14.67" width="34.27" height="1.63" fill="#fff" />
      <rect y="17.93" width="34.27" height="1.63" fill="#fff" />
    </g>
    <rect y=".05" width="12.81" height="9.87" fill="#2f4794" />
    <g>
      <g>
        <polygon
          points="10.71 2.01 10.84 2.39 10.52 2.15 10.52 2.15 10.52 2.15 10.2 2.39 10.33 2.01 10.33 2.01 10.33 2.01 10 1.79 10.4 1.79 10.51 1.4 10.63 1.79 10.63 1.79 10.64 1.79 11.04 1.79 10.71 2.01 10.7 2.01 10.71 2.01"
          fill="#fff"
        />
        <polygon
          points="10.71 4.01 10.84 4.39 10.52 4.15 10.52 4.15 10.52 4.15 10.2 4.39 10.33 4.01 10.33 4 10.33 4 10 3.78 10.4 3.78 10.51 3.39 10.63 3.78 10.63 3.78 10.64 3.78 11.04 3.78 10.71 4 10.7 4 10.71 4.01"
          fill="#fff"
        />
        <polygon
          points="10.71 6 10.84 6.38 10.52 6.14 10.52 6.14 10.52 6.14 10.2 6.38 10.33 6 10.33 6 10.33 6 10 5.77 10.4 5.77 10.51 5.39 10.63 5.77 10.63 5.77 10.64 5.77 11.04 5.77 10.71 6 10.7 6 10.71 6"
          fill="#fff"
        />
        <polygon
          points="10.71 7.99 10.84 8.37 10.52 8.13 10.52 8.13 10.52 8.13 10.2 8.37 10.33 7.99 10.33 7.99 10.33 7.99 10 7.76 10.4 7.76 10.51 7.38 10.63 7.76 10.63 7.77 10.64 7.76 11.04 7.76 10.71 7.99 10.7 7.99 10.71 7.99"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="8.59 2.01 8.73 2.39 8.4 2.15 8.4 2.15 8.4 2.15 8.08 2.39 8.21 2.01 8.21 2.01 8.21 2.01 7.88 1.79 8.28 1.79 8.39 1.4 8.52 1.79 8.51 1.79 8.52 1.79 8.92 1.79 8.59 2.01 8.58 2.01 8.59 2.01"
          fill="#fff"
        />
        <polygon
          points="8.59 4.01 8.73 4.39 8.4 4.15 8.4 4.15 8.4 4.15 8.08 4.39 8.21 4.01 8.21 4 8.21 4 7.88 3.78 8.28 3.78 8.39 3.39 8.52 3.78 8.51 3.78 8.52 3.78 8.92 3.78 8.59 4 8.58 4 8.59 4.01"
          fill="#fff"
        />
        <polygon
          points="8.59 6 8.73 6.38 8.4 6.14 8.4 6.14 8.4 6.14 8.08 6.38 8.21 6 8.21 6 8.21 6 7.88 5.77 8.28 5.77 8.39 5.39 8.52 5.77 8.51 5.77 8.52 5.77 8.92 5.77 8.59 6 8.58 6 8.59 6"
          fill="#fff"
        />
        <polygon
          points="8.59 7.99 8.73 8.37 8.4 8.13 8.4 8.13 8.4 8.13 8.08 8.37 8.21 7.99 8.21 7.99 8.21 7.99 7.88 7.76 8.28 7.76 8.39 7.38 8.52 7.76 8.51 7.77 8.52 7.76 8.92 7.76 8.59 7.99 8.58 7.99 8.59 7.99"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="6.47 2.01 6.61 2.39 6.28 2.15 6.28 2.15 6.28 2.15 5.96 2.39 6.09 2.01 6.1 2.01 6.09 2.01 5.76 1.79 6.16 1.79 6.27 1.4 6.4 1.79 6.39 1.79 6.4 1.79 6.8 1.79 6.47 2.01 6.47 2.01 6.47 2.01"
          fill="#fff"
        />
        <polygon
          points="6.47 4.01 6.61 4.39 6.28 4.15 6.28 4.15 6.28 4.15 5.96 4.39 6.09 4.01 6.1 4 6.09 4 5.76 3.78 6.16 3.78 6.27 3.39 6.4 3.78 6.39 3.78 6.4 3.78 6.8 3.78 6.47 4 6.47 4 6.47 4.01"
          fill="#fff"
        />
        <polygon
          points="6.47 6 6.61 6.38 6.28 6.14 6.28 6.14 6.28 6.14 5.96 6.38 6.09 6 6.1 6 6.09 6 5.76 5.77 6.16 5.77 6.27 5.39 6.4 5.77 6.39 5.77 6.4 5.77 6.8 5.77 6.47 6 6.47 6 6.47 6"
          fill="#fff"
        />
        <polygon
          points="6.47 7.99 6.61 8.37 6.28 8.13 6.28 8.13 6.28 8.13 5.96 8.37 6.09 7.99 6.1 7.99 6.09 7.99 5.76 7.76 6.16 7.76 6.27 7.38 6.4 7.76 6.39 7.77 6.4 7.76 6.8 7.76 6.47 7.99 6.47 7.99 6.47 7.99"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="4.39 2.01 4.52 2.39 4.2 2.15 4.2 2.15 4.2 2.15 3.87 2.39 4.01 2.01 4.01 2.01 4.01 2.01 3.67 1.79 4.08 1.79 4.19 1.4 4.31 1.79 4.31 1.79 4.31 1.79 4.72 1.79 4.38 2.01 4.38 2.01 4.39 2.01"
          fill="#fff"
        />
        <polygon
          points="4.39 4.01 4.52 4.39 4.2 4.15 4.2 4.15 4.2 4.15 3.87 4.39 4.01 4.01 4.01 4 4.01 4 3.67 3.78 4.08 3.78 4.19 3.39 4.31 3.78 4.31 3.78 4.31 3.78 4.72 3.78 4.38 4 4.38 4 4.39 4.01"
          fill="#fff"
        />
        <polygon
          points="4.39 6 4.52 6.38 4.2 6.14 4.2 6.14 4.2 6.14 3.87 6.38 4.01 6 4.01 6 4.01 6 3.67 5.77 4.08 5.77 4.19 5.39 4.31 5.77 4.31 5.77 4.31 5.77 4.72 5.77 4.38 6 4.38 6 4.39 6"
          fill="#fff"
        />
        <polygon
          points="4.39 7.99 4.52 8.37 4.2 8.13 4.2 8.13 4.2 8.13 3.87 8.37 4.01 7.99 4.01 7.99 4.01 7.99 3.67 7.76 4.08 7.76 4.19 7.38 4.31 7.76 4.31 7.77 4.31 7.76 4.72 7.76 4.38 7.99 4.38 7.99 4.39 7.99"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="2.3 2.01 2.43 2.39 2.11 2.15 2.11 2.15 2.11 2.15 1.79 2.39 1.92 2.01 1.92 2.01 1.92 2.01 1.59 1.79 1.99 1.79 2.1 1.4 2.23 1.79 2.23 1.79 2.23 1.79 2.63 1.79 2.3 2.01 2.29 2.01 2.3 2.01"
          fill="#fff"
        />
        <polygon
          points="2.3 4.01 2.43 4.39 2.11 4.15 2.11 4.15 2.11 4.15 1.79 4.39 1.92 4.01 1.92 4 1.92 4 1.59 3.78 1.99 3.78 2.1 3.39 2.23 3.78 2.23 3.78 2.23 3.78 2.63 3.78 2.3 4 2.29 4 2.3 4.01"
          fill="#fff"
        />
        <polygon
          points="2.3 6 2.43 6.38 2.11 6.14 2.11 6.14 2.11 6.14 1.79 6.38 1.92 6 1.92 6 1.92 6 1.59 5.77 1.99 5.77 2.1 5.39 2.23 5.77 2.23 5.77 2.23 5.77 2.63 5.77 2.3 6 2.29 6 2.3 6"
          fill="#fff"
        />
        <polygon
          points="2.3 7.99 2.43 8.37 2.11 8.13 2.11 8.13 2.11 8.13 1.79 8.37 1.92 7.99 1.92 7.99 1.92 7.99 1.59 7.76 1.99 7.76 2.1 7.38 2.23 7.76 2.23 7.77 2.23 7.76 2.63 7.76 2.3 7.99 2.29 7.99 2.3 7.99"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="11.74 3.01 11.87 3.39 11.55 3.15 11.55 3.15 11.55 3.15 11.22 3.39 11.36 3.01 11.36 3 11.36 3 11.03 2.78 11.43 2.78 11.54 2.39 11.66 2.78 11.66 2.78 11.66 2.78 12.07 2.78 11.73 3 11.73 3 11.74 3.01"
          fill="#fff"
        />
        <polygon
          points="11.74 5 11.87 5.38 11.55 5.14 11.55 5.14 11.55 5.14 11.22 5.38 11.36 5 11.36 5 11.36 5 11.03 4.77 11.43 4.77 11.54 4.39 11.66 4.77 11.66 4.77 11.66 4.77 12.07 4.77 11.73 5 11.73 5 11.74 5"
          fill="#fff"
        />
        <polygon
          points="11.74 7 11.87 7.38 11.55 7.14 11.55 7.14 11.55 7.14 11.22 7.38 11.36 7 11.36 6.99 11.36 6.99 11.03 6.77 11.43 6.77 11.54 6.38 11.66 6.77 11.66 6.77 11.66 6.77 12.07 6.77 11.73 6.99 11.73 6.99 11.74 7"
          fill="#fff"
        />
        <polygon
          points="11.74 8.99 11.87 9.38 11.55 9.13 11.55 9.13 11.55 9.13 11.22 9.38 11.36 8.99 11.36 8.99 11.36 8.99 11.03 8.77 11.43 8.77 11.54 8.38 11.66 8.77 11.66 8.77 11.66 8.77 12.07 8.77 11.73 8.99 11.73 8.99 11.74 8.99"
          fill="#fff"
        />
        <polygon
          points="11.74 1.02 11.87 1.4 11.55 1.17 11.55 1.16 11.55 1.17 11.22 1.4 11.36 1.02 11.36 1.02 11.36 1.02 11.03 .79 11.43 .79 11.54 .41 11.66 .79 11.66 .8 11.66 .79 12.07 .79 11.73 1.02 11.73 1.02 11.74 1.02"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="9.66 3.01 9.8 3.39 9.48 3.15 9.48 3.15 9.48 3.15 9.15 3.39 9.29 3.01 9.29 3 9.29 3 8.95 2.78 9.36 2.78 9.47 2.39 9.59 2.78 9.59 2.78 9.59 2.78 10 2.78 9.66 3 9.66 3 9.66 3.01"
          fill="#fff"
        />
        <polygon
          points="9.66 5 9.8 5.38 9.48 5.14 9.48 5.14 9.48 5.14 9.15 5.38 9.29 5 9.29 5 9.29 5 8.95 4.77 9.36 4.77 9.47 4.39 9.59 4.77 9.59 4.77 9.59 4.77 10 4.77 9.66 5 9.66 5 9.66 5"
          fill="#fff"
        />
        <polygon
          points="9.66 7 9.8 7.38 9.48 7.14 9.48 7.14 9.48 7.14 9.15 7.38 9.29 7 9.29 6.99 9.29 6.99 8.95 6.77 9.36 6.77 9.47 6.38 9.59 6.77 9.59 6.77 9.59 6.77 10 6.77 9.66 6.99 9.66 6.99 9.66 7"
          fill="#fff"
        />
        <polygon
          points="9.66 8.99 9.8 9.38 9.48 9.13 9.48 9.13 9.48 9.13 9.15 9.38 9.29 8.99 9.29 8.99 9.29 8.99 8.95 8.77 9.36 8.77 9.47 8.38 9.59 8.77 9.59 8.77 9.59 8.77 10 8.77 9.66 8.99 9.66 8.99 9.66 8.99"
          fill="#fff"
        />
        <polygon
          points="9.66 1.02 9.8 1.4 9.48 1.17 9.48 1.16 9.48 1.17 9.15 1.4 9.29 1.02 9.29 1.02 9.29 1.02 8.95 .79 9.36 .79 9.47 .41 9.59 .79 9.59 .8 9.59 .79 10 .79 9.66 1.02 9.66 1.02 9.66 1.02"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="7.51 3.01 7.65 3.39 7.32 3.15 7.32 3.15 7.32 3.15 7 3.39 7.13 3.01 7.13 3 7.13 3 6.8 2.78 7.2 2.78 7.31 2.39 7.43 2.78 7.43 2.78 7.44 2.78 7.84 2.78 7.51 3 7.5 3 7.51 3.01"
          fill="#fff"
        />
        <polygon
          points="7.51 5 7.65 5.38 7.32 5.14 7.32 5.14 7.32 5.14 7 5.38 7.13 5 7.13 5 7.13 5 6.8 4.77 7.2 4.77 7.31 4.39 7.43 4.77 7.43 4.77 7.44 4.77 7.84 4.77 7.51 5 7.5 5 7.51 5"
          fill="#fff"
        />
        <polygon
          points="7.51 7 7.65 7.38 7.32 7.14 7.32 7.14 7.32 7.14 7 7.38 7.13 7 7.13 6.99 7.13 6.99 6.8 6.77 7.2 6.77 7.31 6.38 7.43 6.77 7.43 6.77 7.44 6.77 7.84 6.77 7.51 6.99 7.5 6.99 7.51 7"
          fill="#fff"
        />
        <polygon
          points="7.51 8.99 7.65 9.38 7.32 9.13 7.32 9.13 7.32 9.13 7 9.38 7.13 8.99 7.13 8.99 7.13 8.99 6.8 8.77 7.2 8.77 7.31 8.38 7.43 8.77 7.43 8.77 7.44 8.77 7.84 8.77 7.51 8.99 7.5 8.99 7.51 8.99"
          fill="#fff"
        />
        <polygon
          points="7.51 1.02 7.65 1.4 7.32 1.17 7.32 1.16 7.32 1.17 7 1.4 7.13 1.02 7.13 1.02 7.13 1.02 6.8 .79 7.2 .79 7.31 .41 7.43 .79 7.43 .8 7.44 .79 7.84 .79 7.51 1.02 7.5 1.02 7.51 1.02"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="5.4 3.01 5.54 3.39 5.21 3.15 5.21 3.15 5.21 3.15 4.89 3.39 5.02 3.01 5.03 3 5.02 3 4.69 2.78 5.09 2.78 5.2 2.39 5.33 2.78 5.33 2.78 5.33 2.78 5.73 2.78 5.4 3 5.4 3 5.4 3.01"
          fill="#fff"
        />
        <polygon
          points="5.4 5 5.54 5.38 5.21 5.14 5.21 5.14 5.21 5.14 4.89 5.38 5.02 5 5.03 5 5.02 5 4.69 4.77 5.09 4.77 5.2 4.39 5.33 4.77 5.33 4.77 5.33 4.77 5.73 4.77 5.4 5 5.4 5 5.4 5"
          fill="#fff"
        />
        <polygon
          points="5.4 7 5.54 7.38 5.21 7.14 5.21 7.14 5.21 7.14 4.89 7.38 5.02 7 5.03 6.99 5.02 6.99 4.69 6.77 5.09 6.77 5.2 6.38 5.33 6.77 5.33 6.77 5.33 6.77 5.73 6.77 5.4 6.99 5.4 6.99 5.4 7"
          fill="#fff"
        />
        <polygon
          points="5.4 8.99 5.54 9.38 5.21 9.13 5.21 9.13 5.21 9.13 4.89 9.38 5.02 8.99 5.03 8.99 5.02 8.99 4.69 8.77 5.09 8.77 5.2 8.38 5.33 8.77 5.33 8.77 5.33 8.77 5.73 8.77 5.4 8.99 5.4 8.99 5.4 8.99"
          fill="#fff"
        />
        <polygon
          points="5.4 1.02 5.54 1.4 5.21 1.17 5.21 1.16 5.21 1.17 4.89 1.4 5.02 1.02 5.03 1.02 5.02 1.02 4.69 .79 5.09 .79 5.2 .41 5.33 .79 5.33 .8 5.33 .79 5.73 .79 5.4 1.02 5.4 1.02 5.4 1.02"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="3.34 3.01 3.47 3.39 3.15 3.15 3.15 3.15 3.15 3.15 2.82 3.39 2.96 3.01 2.96 3 2.96 3 2.63 2.78 3.03 2.78 3.14 2.39 3.26 2.78 3.26 2.78 3.26 2.78 3.67 2.78 3.33 3 3.33 3 3.34 3.01"
          fill="#fff"
        />
        <polygon
          points="3.34 5 3.47 5.38 3.15 5.14 3.15 5.14 3.15 5.14 2.82 5.38 2.96 5 2.96 5 2.96 5 2.63 4.77 3.03 4.77 3.14 4.39 3.26 4.77 3.26 4.77 3.26 4.77 3.67 4.77 3.33 5 3.33 5 3.34 5"
          fill="#fff"
        />
        <polygon
          points="3.34 7 3.47 7.38 3.15 7.14 3.15 7.14 3.15 7.14 2.82 7.38 2.96 7 2.96 6.99 2.96 6.99 2.63 6.77 3.03 6.77 3.14 6.38 3.26 6.77 3.26 6.77 3.26 6.77 3.67 6.77 3.33 6.99 3.33 6.99 3.34 7"
          fill="#fff"
        />
        <polygon
          points="3.34 8.99 3.47 9.38 3.15 9.13 3.15 9.13 3.15 9.13 2.82 9.38 2.96 8.99 2.96 8.99 2.96 8.99 2.63 8.77 3.03 8.77 3.14 8.38 3.26 8.77 3.26 8.77 3.26 8.77 3.67 8.77 3.33 8.99 3.33 8.99 3.34 8.99"
          fill="#fff"
        />
        <polygon
          points="3.34 1.02 3.47 1.4 3.15 1.17 3.15 1.16 3.15 1.17 2.82 1.4 2.96 1.02 2.96 1.02 2.96 1.02 2.63 .79 3.03 .79 3.14 .41 3.26 .79 3.26 .8 3.26 .79 3.67 .79 3.33 1.02 3.33 1.02 3.34 1.02"
          fill="#fff"
        />
      </g>
      <g>
        <polygon
          points="1.24 3.01 1.37 3.39 1.05 3.15 1.05 3.15 1.05 3.15 .73 3.39 .86 3.01 .87 3 .86 3 .53 2.78 .93 2.78 1.04 2.39 1.16 2.78 1.16 2.78 1.16 2.78 1.57 2.78 1.24 3 1.24 3 1.24 3.01"
          fill="#fff"
        />
        <polygon
          points="1.24 5 1.37 5.38 1.05 5.14 1.05 5.14 1.05 5.14 .73 5.38 .86 5 .87 5 .86 5 .53 4.77 .93 4.77 1.04 4.39 1.16 4.77 1.16 4.77 1.16 4.77 1.57 4.77 1.24 5 1.24 5 1.24 5"
          fill="#fff"
        />
        <polygon
          points="1.24 7 1.37 7.38 1.05 7.14 1.05 7.14 1.05 7.14 .73 7.38 .86 7 .87 6.99 .86 6.99 .53 6.77 .93 6.77 1.04 6.38 1.16 6.77 1.16 6.77 1.16 6.77 1.57 6.77 1.24 6.99 1.24 6.99 1.24 7"
          fill="#fff"
        />
        <polygon
          points="1.24 8.99 1.37 9.38 1.05 9.13 1.05 9.13 1.05 9.13 .73 9.38 .86 8.99 .87 8.99 .86 8.99 .53 8.77 .93 8.77 1.04 8.38 1.16 8.77 1.16 8.77 1.16 8.77 1.57 8.77 1.24 8.99 1.24 8.99 1.24 8.99"
          fill="#fff"
        />
        <polygon
          points="1.24 1.02 1.37 1.4 1.05 1.17 1.05 1.16 1.05 1.17 .73 1.4 .86 1.02 .87 1.02 .86 1.02 .53 .79 .93 .79 1.04 .41 1.16 .79 1.16 .8 1.16 .79 1.57 .79 1.24 1.02 1.24 1.02 1.24 1.02"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
</template>
